import { c as _c } from "react/compiler-runtime";
import { LotShipmentDescriptionData, getLotShipmentDescription } from "@/components/ui/lot-number-details";
import { LotRowLabel } from "@/components/ui/lot-number-select";

/** Product-first receipt details shared by dose and checkout lot selection. */
export function LotShipmentDetails(t0) {
  const $ = _c(12);
  const {
    shipment,
    productName,
    locationNames
  } = t0;
  const t1 = shipment.medicationName ?? productName;
  const t2 = shipment.chargedTodayQuantity != null;
  let t3;
  if ($[0] !== shipment.lotNumber || $[1] !== t1 || $[2] !== t2) {
    t3 = <LotRowLabel lotNumber={shipment.lotNumber} productName={t1} chargedToday={t2} wrap={true} />;
    $[0] = shipment.lotNumber;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== locationNames || $[5] !== shipment) {
    t4 = getLotShipmentDescription(shipment, locationNames);
    $[4] = locationNames;
    $[5] = shipment;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <p className="mt-0.5 w-full whitespace-normal break-words text-caption text-foreground-secondary">{t4}</p>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="min-w-0 w-full flex-1 whitespace-normal break-words">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}